(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-countdown')) {
    class AnnouncementCountdown extends HTMLElement {
      connectedCallback() {
        this.end = new Date(this.dataset.end).getTime();
        this.timeEl = this.querySelector('.announcement-bar__countdown-time');
        this.showSeconds = this.dataset.showSeconds === 'true';

        // Invalid date/time entered in the editor: stay hidden
        if (isNaN(this.end) || !this.timeEl) return;

        this.tick = this.tick.bind(this);
        this.tick();
        this.interval = setInterval(this.tick, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      pad(n) {
        return String(n).padStart(2, '0');
      }

      tick() {
        const diff = this.end - Date.now();

        if (diff <= 0) {
          clearInterval(this.interval);
          this.finish();
          return;
        }

        const s = Math.floor(diff / 1000);
        const days = Math.floor(s / 86400);
        const hours = Math.floor((s % 86400) / 3600);
        const mins = Math.floor((s % 3600) / 60);
        const secs = s % 60;

        const values = { d: String(days), h: this.pad(hours), m: this.pad(mins), s: this.pad(secs) };

        this.timeEl.querySelectorAll('[data-unit]').forEach((unit) => {
          const key = unit.dataset.unit;
          const num = unit.querySelector('.announcement-bar__countdown-num');
          if (num && num.textContent !== values[key]) num.textContent = values[key];
          if (key === 'd') unit.hidden = days === 0;
        });

        this.timeEl.setAttribute(
          'aria-label',
          `${days > 0 ? days + ' days ' : ''}${hours} hours ${mins} minutes${this.showSeconds ? ' ' + secs + ' seconds' : ''}`
        );
        this.hidden = false;
      }

      finish() {
        if (this.dataset.hideOnEnd === 'true' && !window.Shopify?.designMode) {
          const section = this.closest('.shopify-section');
          if (section) section.style.display = 'none';
          return;
        }

        const expired = this.dataset.expiredText;
        if (expired) {
          this.innerHTML = '';
          const span = document.createElement('span');
          span.className = 'announcement-bar__countdown-label';
          span.textContent = expired;
          this.appendChild(span);
          this.hidden = false;
        } else {
          this.hidden = true;
        }
      }
    }

    customElements.define('announcement-countdown', AnnouncementCountdown);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-redesign"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
